import {
    EXPENSE_CREATE_FAIL, EXPENSE_CREATE_REQUEST,
    EXPENSE_CREATE_SUCCESS, EXPENSE_DELETE_FAIL, EXPENSE_DELETE_REQUEST, EXPENSE_DELETE_SUCCESS,
    EXPENSE_DELIVERED_FAIL,
    EXPENSE_DELIVERED_REQUEST,
    EXPENSE_DELIVERED_SUCCESS,
    EXPENSE_DETAILS_FAIL,
    EXPENSE_DETAILS_REQUEST,
    EXPENSE_DETAILS_SUCCESS,
    EXPENSE_LIST_FAIL,
    EXPENSE_LIST_REQUEST,
    EXPENSE_LIST_SUCCESS, EXPENSE_UPDATE_FAIL, EXPENSE_UPDATE_REQUEST, EXPENSE_UPDATE_SUCCESS,

} from "../Constants/ExpenseConstants";





import axios from "axios";
import { logout } from "./userActions";
import {toast} from "react-toastify";
import {URL} from "../Url";

export const listExpenses = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPENSE_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${URL}/api/expenses/all`, config);

    dispatch({ type: EXPENSE_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: EXPENSE_LIST_FAIL,
      payload: message,
    });
  }
};

// EXPENSE DETAILS
export const getExpenseDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPENSE_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${URL}/api/expenses/${id}`, config);
    dispatch({ type: EXPENSE_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: EXPENSE_DETAILS_FAIL,
      payload: message,
    });
  }
};

// EXPENSE DELIVER
export const deliverExpense = (expense) => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPENSE_DELIVERED_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${URL}/api/expenses/${expense._id}/delivered`,
      {},
      config
    );
    dispatch({ type: EXPENSE_DELIVERED_SUCCESS, payload: data });
    toast.success("Expense delivered successfully");
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: EXPENSE_DELIVERED_FAIL,
      payload: message,
    });
      toast.warn(message)
  }

};


// EXPENSE ADD
export const createExpense = (expenses) => async(dispatch,getState) => {
  try{
    dispatch({type : EXPENSE_CREATE_REQUEST})

    const {
      userLogin : {userInfo}
    } = getState()

    const config = {
      headers : {
        "Content-Type" : "application/json",
        Authorization : `Bearer ${userInfo.token}`
      }
    }
    const {data} = await axios.post(`${URL}/api/expenses`,expenses,config)
    dispatch({type : EXPENSE_CREATE_SUCCESS,payload : data})
    toast.success("Expense created successfully");

    //More codes to add
  }catch(err){
    const message = err.response && err.response.data.message ? err.response.data.message : err.message

    if(message === "Not authorized, token failed"){
      dispatch(logout())
    }
    dispatch({type : EXPENSE_CREATE_FAIL,payload : message})
  }
}

//make expense paid by id

export const makeExpensePaid = (expense) => async(dispatch,getState) => {
    try{
        dispatch({type : EXPENSE_UPDATE_REQUEST})

        const {
        userLogin : {userInfo}
        } = getState()

        const config = {
        headers : {
            "Content-Type" : "application/json",
            Authorization : `Bearer ${userInfo.token}`
        }
        }
        const {data} = await axios.put(`${URL}/api/expenses/${expense._id}/pay`,{},config)
        dispatch({type : EXPENSE_UPDATE_SUCCESS,payload : data})
        toast.success("Expense paid successfully");

        //More codes to add
    }catch(err){
        const message = err.response && err.response.data.message ? err.response.data.message : err.message

        if(message === "Not authorized, token failed"){
        dispatch(logout())
        }
        dispatch({type : EXPENSE_UPDATE_FAIL,payload : message})
    }
}

//make expense shipped by id

    export const makeExpenseShipped = (expense) => async(dispatch,getState) => {
          try{
                dispatch({type : EXPENSE_UPDATE_REQUEST})

                const {
                userLogin : {userInfo}
                } = getState()

                const config = {
                headers : {
                    "Content-Type" : "application/json",
                    Authorization : `Bearer ${userInfo.token}`
                }
                }
                const {data} = await axios.put(`${URL}/api/expenses/${expense._id}/ship`,{},config)
                dispatch({type : EXPENSE_UPDATE_SUCCESS,payload : data})
                toast.success("Expense shipped successfully");

                //More codes to add
            }catch(err){
                const message = err.response && err.response.data.message ? err.response.data.message : err.message

                if(message === "Not authorized, token failed"){
                dispatch(logout())
                }
                dispatch({type : EXPENSE_UPDATE_FAIL,payload : message})
            }
    }


    //delete expense
    export const deleteExpense = (expense) => async(dispatch,getState) => {

        try{
            dispatch({type : EXPENSE_DELETE_REQUEST})

            const {
            userLogin : {userInfo}
            } = getState()

            const config = {
            headers : {
                "Content-Type" : "application/json",
                Authorization : `Bearer ${userInfo.token}`
            }
            }
            const {data} = await axios.delete(`${URL}/api/expenses/${expense._id}`,config)
            dispatch({type : EXPENSE_DELETE_SUCCESS,payload : data})
            toast.success("Expense deleted successfully");

            //More codes to add
        }catch(err){
            const message = err.response && err.response.data.message ? err.response.data.message : err.message

            if(message === "Not authorized, token failed"){
            dispatch(logout())
            }
            dispatch({type : EXPENSE_DELETE_FAIL,payload : message})
        }
    }

    //edit expenseTotalPrice ,expensePaidAmount ,expenseDueAmount
    export const editExpenseMoneyDetails = (expense,expenseTotalPrice,expensePaidAmount,expenseDueAmount) => async(dispatch,getState) => {
        try{
            dispatch({type : EXPENSE_UPDATE_REQUEST})

            const {
            userLogin : {userInfo}
            } = getState()

            const config = {
            headers : {
                "Content-Type" : "application/json",
                Authorization : `Bearer ${userInfo.token}`
            }
            }
            const {data} = await axios.put(`${URL}/api/expenses/${expense._id}/editMoneyDetails`,{expenseTotalPrice,expensePaidAmount,expenseDueAmount},config)
            dispatch({type : EXPENSE_UPDATE_SUCCESS,payload : data})
            toast.success("Expense updated successfully");

            //More codes to add
        }catch(err){
            const message = err.response && err.response.data.message ? err.response.data.message : err.message

            if(message === "Not authorized, token failed"){
            dispatch(logout())
            }
            dispatch({type : EXPENSE_UPDATE_FAIL,payload : message})
        }
    }
